
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.211 18.213a.833.833 0 00.59.244h.416a.85.85 0 00.584-.241l3.083-3.092h5.083a1.667 1.667 0 001.667-1.667V4.791a1.667 1.667 0 00-1.667-1.667H3.634a1.667 1.667 0 00-1.667 1.667v8.666a1.667 1.667 0 001.667 1.667h3.333v2.5c0 .221.088.433.244.59zm-.91-8.089a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z","fill":"#F1A716"}})])
          )
        }
      }
    